<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M23 7v18H9V7h14m0-2H9a2 2 0 00-2 2v18a2 2 0 002 2h14a2 2 0 002-2V7a2 2 0 00-2-2z"/><path d="M20.5 11.5h-9a.5.5 0 010-1h9a.5.5 0 010 1zM17 16.5h-5.5a.5.5 0 010-1H17a.5.5 0 010 1zM20.5 16.5h-1.29a.5.5 0 010-1h1.29a.5.5 0 010 1zM17 21.5h-5.5a.5.5 0 010-1H17a.5.5 0 010 1zM20.5 21.5h-1.29a.5.5 0 010-1h1.29a.5.5 0 010 1z"/></svg>